import React from "react";
import DolorIcon from "../../../assets/img/png/dolorIcon.png";

const TotalIncome = ({ adminDashboard, loading }) => {
  return (
    <div className="col-xxl-4 col-md-6 ">
      <div className="d-flex p-3 h-100 justify-content-between align-items-center box-shadow br-10 bg-white ">
        <div>
          <p className="common-text fs-xs-14">Total Income</p>
          <h1 className="common-heading-Medium ">
            {loading ? (
              <p className="common-text fs-xs-14 mb-0 fw-bold">Loading...</p>
            ) : (
              `$ ${adminDashboard.total_money ? adminDashboard.total_money : 0}`
            )}
          </h1>
        </div>
        <span
          className="rounded-50  dashboard-icon d-inline-block "
          style={{
            backgroundColor: "#ecf9f4",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundImage: `url(${DolorIcon})`,
          }}
        ></span>
      </div>
    </div>
  );
};

export default TotalIncome;
